/** @format */

export const RISKIFIED_KEY_PAGES: { pattern: RegExp; pageName: string }[] = [
    { pattern: /^\/s\/checkout(?:\/.*)?$/, pageName: 'checkout' },
];
